// Dates are compared as local school dates, never UTC calendar days.
export function thaiSchoolDate(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Bangkok', year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(now);
  const value = key => parts.find(part => part.type === key).value;
  return `${value('year')}-${value('month')}-${value('day')}`;
}
export function semesterForDate(settings, date = thaiSchoolDate()) {
  const rows = (settings || []).filter(row => row.is_active !== false && Number(row.is_active ?? 1) !== 0)
    .map(row => ({ term: Number(row.team), start: String(row.start_date || '').slice(0, 10), end: String(row.end_date || '').slice(0, 10) }))
    .filter(row => [1, 2].includes(row.term) && /^\d{4}-\d{2}-\d{2}$/.test(row.start) && row.start !== '0000-00-00')
    .sort((a, b) => b.start.localeCompare(a.start) || b.term - a.term);
  const matching = rows.find(row => date >= row.start && row.end && date <= row.end);
  if (matching) return matching.term;
  // During the break retain the most recently opened term; before opening use the first term.
  const previous = rows.find(row => date >= row.start);
  if (previous) return previous.term;
  if (rows.length) return rows[rows.length - 1].term;
  const month = Number(date.slice(5, 7));
  return month >= 5 && month <= 10 ? 1 : 2;
}
